import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../assets/icons/close-circle.svg';
import { ReactComponent as ExpandIcon } from '../../assets/icons/tables/expand-icon.svg';
import { ReactComponent as NewTabIcon } from '../../assets/icons/tables/new-tab.svg';

interface PropertiesInterface {
  open: boolean;
  title?: string;
  content: JSX.Element;
  position?: 'right' | 'left';
  closePanel: () => void;
  url?: string;
  urlNewTab?: string;
}

/**
 * Custom Side Panel function component
 * @returns JSX.Element
 */
function SidePaneModel(properties: PropertiesInterface) {
  const { t } = useTranslation('sidePanel');
  const { title, open, position, content, closePanel, url, urlNewTab } = properties;
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Handle close panel function
   */
  const handleClosePanel = () => {
    navigate(location.pathname, { replace: true });
    closePanel();
  };

  /**
   * Handle expand panel function
   */
  const handleExpand = () => {
    handleClosePanel();
    if (url) {
      navigate(url);
    }
  };

  /**
   * Handle new tab function
   */
  const handleNewTab = () => {
    handleClosePanel();
    if (urlNewTab) {
      window.open(urlNewTab, '_blank');
    } else {
      window.open(url, '_blank');
    }
  };

  return open
    ? ReactDOM.createPortal(
        <div className={`custom-side-panel-wrap ${position}`}>
          <div className="custom-side-panel-header">
            {title?.length ? (
              <div className="header-title">
                <p>{t(title)}</p>
              </div>
            ) : (
              <div className="header-icons">
                <ExpandIcon onClick={handleExpand} className="icon" />
                <NewTabIcon onClick={handleNewTab} className="icon" />
              </div>
            )}
            <CloseIcon className="icon" onClick={handleClosePanel} />
          </div>
          <div className="custom-side-panel-content">{content}</div>
        </div>,
        document.body,
      )
    : null;
}
export default SidePaneModel;

SidePaneModel.defaultProps = {
  title: '',
  position: 'right',
};
